// Shared helpers for rounded installment plans.

export function buildPlanProposals(amount, n) {
    // Rounded-installment plans (multiples of 50/25/10 €).
    const cents = Math.round((parseFloat(amount) || 0) * 100);
    n = parseInt(n, 10) || 0;
    if (cents <= 0 || n <= 1) return [];
    const out = [];
    const seen = new Set();
    const push = (plan) => {
        if (plan.some((x) => x <= 0)) return;
        if (Math.round(plan.reduce((a, b) => a + b, 0) * 100) !== cents) return;
        const key = plan.map((x) => x.toFixed(2)).join("|");
        if (seen.has(key)) return;
        seen.add(key);
        out.push(plan);
    };
    // Type A: two rounded values, bigger rates last
    for (const step of [5000, 2500, 1000]) {
        const base = Math.floor(cents / n / step) * step;
        if (base <= 0) continue;
        const remainder = cents - base * n;
        if (remainder <= 0) continue;
        let found = null;
        for (let mult = 1; mult <= 40; mult++) {
            const add = step * mult;
            if (remainder % add === 0) {
                const k = remainder / add;
                if (k >= 1 && k < n) { found = { add, k }; break; }
            }
        }
        if (!found) continue;
        push([
            ...Array(n - found.k).fill(base / 100),
            ...Array(found.k).fill((base + found.add) / 100),
        ]);
    }
    // Type B: n-1 rounded rates + final balance installment (works for any residual)
    for (const step of [5000, 2500, 1000]) {
        for (const base of [Math.floor(cents / n / step) * step, Math.ceil(cents / n / step) * step]) {
            if (base <= 0) continue;
            const last = cents - base * (n - 1);
            if (last <= 0 || last === base) continue;
            push([...Array(n - 1).fill(base / 100), last / 100]);
        }
    }
    return out.slice(0, 5);
}

export function planLabel(plan) {
    const fmt = (v) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);
    const groups = [];
    for (const amt of plan) {
        if (groups.length && groups[groups.length - 1].amt === amt) groups[groups.length - 1].n += 1;
        else groups.push({ amt, n: 1 });
    }
    return groups.map((g) => `${g.n} da ${fmt(g.amt)}`).join(" + ");
}
